import {getLocalData} from '../services/StorageServices'

export const hasFeatureTag = (feature) => {
    const settings = getLocalData('storeSettings', [])
    if (settings.length > 0) {
        const featureTags = settings.find((setting) => setting.key === 'feature_tags')
        if (featureTags && Array.isArray(featureTags.value)) {
            return featureTags.value.includes(feature)
        }
    }
}

export const getSetting = (key) => {
    const settings = getLocalData('storeSettings', [])
    if (settings.length > 0) {
        const setting = settings.find((s) => s.key === key)
        return setting ? setting.value : undefined
    }
}